import { List } from "antd";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import Card from "../../../components/Card/Card";

import { Chart, registerables } from "chart.js";
import { Bar } from "react-chartjs-2";
import { TextComponent } from "../../../components";
import ResetPassword from "../../Auth/ResetPasswrd";
import styles from "./dealership.module.css";
Chart.register(...registerables);

function DealershipDashboard() {
  const user = useSelector((state) => state.AuthReducer.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const Notification = useSelector(
    (state) => state.GeneralReducer.getNotifications,
  );
  const DASHBOARD = useSelector(
    (state) => state.AuthReducer.getDealerDashboard,
  );
  // const isReset = useSelector((state) => state.AuthReducer.isReset);

  useEffect(() => {
    dispatch(AuthMiddleware.getUserData());
    dispatch(AuthMiddleware.getDealershipDashboard());
  }, []);

  const chartData = Object.values(DASHBOARD?.chartData || {});
  const maxValue = Math.max(...chartData);

  const renderRecentOrders = (item, index) => {
    return (
      <div className={styles.productCont}>
        <img src={item?.image} alt="" className={styles.prodImg} />
        <div className={styles.descCont}>
          <TextComponent text={item?.name} className={styles.prodName} />
          <TextComponent text={"Item " + item?.items} />
        </div>
      </div>
    );
  };

  const renderInventory = (item, index) => {
    return (
      <div
        className={styles.productCont}
        style={{ justifyContent: "space-between" }}
      >
        <div className={styles.productRightCont}>
          <img
            src={
              item?.image
                ? item?.image
                : require("../../../assets/images/staticImages/p1.png")
            }
            alt=""
            className={styles.prodImg}
          />
          <div className={styles.descCont}>
            <TextComponent
              text={item?.device_id ? item?.device_id : "--"}
              className={styles.prodName}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            justifyContent: "flex-end",
          }}
        >
          <TextComponent
            text={"Owner"}
            style={{ fontFamily: "Urbanist-bold", fontWeigth: "bold" }}
          />
          {/* <TextComponent
            text={
              item?.shared_access == null
                ? "Not Sold"
                : item?.shared_access?.email
            }
            style={{ fontFamily: "Urbanist-semibold" }}
          /> */}
        </div>
      </div>
    );
  };

  const renderNotification = (item, index) => {
    return (
      <div
        className={styles.productCont}
        style={{ justifyContent: "space-between" }}
      >
        <div className={styles.productRightCont}>
          <div className={styles.descCont}>
            <TextComponent text={item?.title} className={styles.prodName} />
            <TextComponent text={item.description} />
          </div>
        </div>
        <div className={styles.notLeftCont}>
          <TextComponent
            text={item?.is_read == 1 ? "Read" : "Unread"}
            className={styles.status}
          />
          <TextComponent text={item?.time_ago} />
        </div>
      </div>
    );
  };
  return (
    <div className={styles.mainCont}>
      <div className={styles.leftCol}>
        <Card className={styles.stockDetail}>
          <div className={styles.saleCont}>
            <TextComponent text="Total Vehicles" className={styles.name} />
            <TextComponent
              text={
                Number(DASHBOARD?.unprotected_assets_count ?? 0) +
                Number(DASHBOARD?.protected_assets_count ?? 0)
              }
              className={styles.val}
            />
          </div>
          <div className={styles.saleCont}>
            <TextComponent
              text="Unprotected Vehicles"
              className={styles.name}
            />
            <TextComponent
              text={
                DASHBOARD?.unprotected_assets_count
                  ? DASHBOARD?.unprotected_assets_count
                  : "0"
              }
              className={styles.val}
            />
          </div>
          <div className={styles.saleCont}>
            <TextComponent text="Protected Vehicles" className={styles.name} />
            <TextComponent
              text={
                DASHBOARD?.protected_assets_count
                  ? DASHBOARD?.protected_assets_count
                  : "0"
              }
              className={styles.val}
            />
          </div>
        </Card>
        {/* <Card>
          <div className={styles.orderMainCont}>
            <TextComponent text="Recent order" className={styles.headerHead} />
            {recentOrders?.length > 2 && 
            <TextComponent
              text="See All"
              className={styles.seeAll}
              onClick={() => navigate("/products")}
            />
}
          </div>
          <List dataSource={recentOrders} renderItem={renderRecentOrders} />
        </Card> */}
        <Card>
          <div className={styles.orderMainCont}>
            <TextComponent
              text="Device Inventory"
              className={styles.headerHead}
            />
            {DASHBOARD?.inventory?.length > 3 && (
              <TextComponent
                text="See All"
                className={styles.seeAll}
                onClick={() => navigate("/inventory")}
              />
            )}
          </div>
          <List
            dataSource={DASHBOARD?.inventory.slice(0, 3)}
            renderItem={renderInventory}
          />
        </Card>
      </div>
      <div className={styles.rightCol}>
        <Card>
          <div className={styles.orderMainCont}>
            <TextComponent text="Alerts" className={styles.headerHead} />
            {DASHBOARD?.alerts?.length > 2 && (
              <TextComponent
                text="See All"
                className={styles.seeAll}
                onClick={() => navigate("/notifications")}
              />
            )}
          </div>
          <List
            dataSource={DASHBOARD?.alerts?.slice(0, 2)}
            renderItem={renderNotification}
          />
        </Card>
        <Card>
          <div className={styles.orderMainCont}>
            <TextComponent
              text="Sales overview"
              className={styles.headerHead}
            />
            {/* <TextComponent text="See All" className={styles.seeAll} /> */}
          </div>
          <Bar
            height={200}
            options={{
              responsive: true,
              plugins: {
                legend: {
                  position: "top",
                },
                // title: {
                //   align: "start",
                //   display: true,
                //   // text: SALESHISTORY ? SALESHISTORY?.total_sailed_units : "0",
                //   color: "#ED1C24",
                //   font: { size: 30, family: "Urbanist" },
                // },

                // subtitle: {
                //   align: "start",
                //   display: true,
                //   text: "Units",
                //   color: "#ED1C24",
                //   font: { size: 18, family: "Urbanist", weight: "bold" },
                // },
              },
              scales: {
                y: {
                  beginAtZero: true,
                  min: 0,
                  max: maxValue + 20,
                  ticks: {
                    stepSize: 20,
                  },
                },
              },
            }}
            data={{
              datasets: [
                {
                  label: "Sales overview",
                  data: Object.values(DASHBOARD?.chartData || {}),
                  backgroundColor: "#0050A8",
                },
              ],
              labels: Object.keys(DASHBOARD?.chartData || {}),
            }}
          />
        </Card>
        {/* <ResetPassword
          open={isReset}
        /> */}
      </div>
    </div>
  );
}

export default DealershipDashboard;
